import { render, staticRenderFns } from "./referential-studio.vue?vue&type=template&id=5fff7cfd&"
import script from "./referential-studio.vue?vue&type=script&lang=ts&"
export * from "./referential-studio.vue?vue&type=script&lang=ts&"
import style0 from "./referential-studio.vue?vue&type=style&index=0&id=5fff7cfd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports